import React, { memo } from "react";

// Components
import { CSSTransition, TransitionGroup } from "react-transition-group";

// Types
import { CrossSellItemProps } from "../../types";
import { CartItemWithUUID } from "@swiggy-private/cart-types";

// Components
import { CrossSellM2Item } from "../../../";

// Helpers
import { getCrossSellM2ItemProps } from "@cart-ui/helpers/CrossSellM2";
import { getImageId } from "../../utils";

// Styles
import cx from "classnames";
import styles from "./styles.scss";
import { TransitionGroupContainer, ThatsAllContainer, ThatsAllImage } from "./CrossSellItem.style";
import { isFreebieOptInItem } from "@cart-ui/helpers/Item";

// Constants
import { THATS_ALL_IMAGE_ID, THATS_ALL_ALT_TEXT } from "@cart-ui/components/cross-sell-m2-carousel/constants";

const CrossSellItem = ({
    onAddButtonClick,
    onItemDetailsClick,
    onImpressionCrossSellM2Item,
    onImpressionCarouselItemDetailsPopup,
    crossSellM2ItemsList,
    selectedTab,
    sortedItems,
    isLocked,
    unlockAmount,
    itemPresentationAttributes,
    onImpressionMagicItemsUnlockPopup,
    onClickDismissMagicItemsUnlockPopup,
    onClickExploreMenuMagicItems,
    onExploreMenuClick,
    isMagicItems = false,
    isSnaccStorefrontV2,
}: CrossSellItemProps) => {
    const showThatsAllText = isMagicItems && sortedItems && sortedItems.length > 0 && sortedItems.length <= 3;
    return (
        <div
            className={cx(styles.transition, {
                [styles.transitionV2]: crossSellM2ItemsList?.length && crossSellM2ItemsList.length > 1,
            })}
        >
            <TransitionGroup component={TransitionGroupContainer} key={selectedTab || "0"}>
                {sortedItems?.map((item: CartItemWithUUID, index: number) => {
                    const { itemId, name, finalPrice, imageId, vegType, description, price, itemDiscountPercentage } =
                        getCrossSellM2ItemProps(item);

                    const finalImageId = getImageId(imageId);

                    return (
                        <CSSTransition
                            key={item.menu_item_id}
                            timeout={300}
                            classNames={{
                                enter: styles.itemEnter,
                                enterActive: styles.itemEnterActive,
                                exit: styles.itemExit,
                                exitActive: styles.itemExitActive,
                            }}
                        >
                            <CrossSellM2Item
                                itemId={itemId}
                                name={name}
                                position={index}
                                finalPrice={finalPrice}
                                basePrice={price}
                                imageId={finalImageId}
                                vegType={vegType}
                                onAddButtonClick={onAddButtonClick(item, String(index))}
                                description={description}
                                onClickItemDetailsCarousel={onItemDetailsClick(
                                    String(item.menu_item_id),
                                    String(index),
                                    { basePrice: price, slashedPrice: finalPrice },
                                )}
                                index={item.menu_item_id}
                                onImpressionCrossSellM2Item={onImpressionCrossSellM2Item}
                                onImpressionCarouselItemDetailsPopup={onImpressionCarouselItemDetailsPopup}
                                isFreebieOptInItem={isFreebieOptInItem(item)}
                                isLocked={isLocked}
                                unlockAmount={unlockAmount}
                                itemPresentationAttributes={itemPresentationAttributes}
                                itemDiscountPercentage={itemDiscountPercentage}
                                onImpressionMagicItemsUnlockPopup={onImpressionMagicItemsUnlockPopup}
                                onClickDismissMagicItemsUnlockPopup={onClickDismissMagicItemsUnlockPopup}
                                onClickExploreMenuMagicItems={onClickExploreMenuMagicItems}
                                onExploreMenuClick={onExploreMenuClick}
                                isSnaccStorefrontV2={isSnaccStorefrontV2}
                                tickerResetKey={sortedItems?.length}
                            />
                        </CSSTransition>
                    );
                })}
            </TransitionGroup>
            {showThatsAllText && (
                <ThatsAllContainer>
                    <ThatsAllImage cloudinaryId={THATS_ALL_IMAGE_ID} alt={THATS_ALL_ALT_TEXT} fit="contain" />
                </ThatsAllContainer>
            )}
        </div>
    );
};

export default memo(CrossSellItem);
